export const validateUser = {
  ok: true,
  data: [
    {
      valid: true,
      reason: 'Username is available',
    },
  ],
};
